module.exports = new __parcel__URL__("newyork_banner.2353637a.jpg").toString();